import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import { useDispatch, useSelector } from "react-redux";
import { Row, Label } from "reactstrap";
import { Avatar, Chip, FormGroup, InputLabel, MenuItem } from "@mui/material";
import attachment from "../../assets/images/attachment.png";
import RequestAcceptedPopup from "../RequestAcceptedPopup/RequestAcceptedPopup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import messageIcon from "../../assets/images/envelope.svg";
import Attachments from "../../entities/Attachments";
import UserFund from "../../entities/UserFund";
import RenderInputError from "../../pages/Login/RenderInputError/RenderInputError";
import {
  GetMemberDetails,
  memberDetailsUtil,
} from "../../services/GetMemberDetails";
import { SendContactMail } from "../../services/SendContactMail";
import ContactData from "../../entities/ContactData";
import ErrorPopup from "../ErrorPopup/ErrorPopup";
import ContactPopupValues from "../../entities/ContactPopupValues";
import { GetCities } from "../../services/GetCities";
import { getCityLabel } from "../../utils/helpers/MemberDataHelper";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";
import "./ContantPopupForm.scss";
import useInputFocus from "../../customHooks/useInputFocus";
import Pdf from '../../assets/images/pdf.png'
import { grey, pink } from '@mui/material/colors';
import { styled } from "@mui/styles";
// const ATTACHMENTS_INITIAL_VALUE: Attachments[] = [
//   {
//     base64: "",
//     fileName: "test.pdf",
//   },
// ];

const FIVE_MB_IN_BYTES = 5000000;



const ContantPopupForm = (props: { size?: string; center?: boolean }) => {
  const { userFunds } = useSelector((state: any) => state.UserReducer);
  const { activeFund } = useSelector((state: any) => state.DashboardReducer);
  const { t } = useTranslation("common");
  const [clickbtnsub , setClickbtnsub] = useState<boolean>(false);
  
  const MuiChipCustom = styled(Chip)(() => ({
    // width: 150, //adding custom css styles
    // height: 50,
    backgroundColor: 'cream',
    borderRadius: 25,
    color: 'white',   
 
    '& .MuiChip-label': {
       color: 'black', //using the MUI chip label properties
       fontSize: 20
    },
 
    '& .MuiChip-deleteIcon': {
       color: 'black',
       fontSize: 20
    },
 }));

  const validate = (values: ContactPopupValues) => {
    const errors: any = {};
    if (!values.selectedFund) {
      errors.selectedFund = t("contactPopupForm.fundNull");
    }
    if (!values.contactSubject) {
      errors.contactSubject = t("contactPopupForm.subjectNull");
    }
    if (!values.contactDesc) {
      errors.contactDesc = t("contactPopupForm.descNull");
    } else if (values.contactDesc.length > 500) {
      errors.contactDesc = t("contactPopupForm.descLong");
    } else if (values.contactDesc.length < 10) {
      errors.contactDesc = t("contactPopupForm.descShort");
    }
    return errors;
  };

  const getUserFunds = () => {
    // Remove fund in case the user is amit and gimlai in same fund
    let fundsCode: string[] = [];
    return userFunds.filter((fund: UserFund) => {
      if (!fundsCode.includes(fund.fundCode)) {
        fundsCode.push(fund.fundCode);
        return true;
      }
      return false;
    });
  };

  const getDefaultFundLabel = () =>
    Object.keys(activeFund).length
      ? `${activeFund.fundLabel}`
      : `${getUserFunds()[0]?.fundLabel}`;

  const formik = useFormik({
    initialValues: {
      selectedFund: getDefaultFundLabel(),
      contactSubject: "",
      contactDesc: "",
    },    
    validate,
    onSubmit: async (values: ContactPopupValues) => {
      setLoading(true);
      const memberData = await GetMemberDetails();
      if (memberDetailsUtil.isValid(memberData)) {
        const cityLabel = await getCityLabelByCode(memberData.cityCode);
        const contactData: ContactData = {
          memberID: `${memberData.memberId}`,
          contactSubject: values?.contactSubject,
          contactChannel: "אתר האונליין",
          contactDescription: values?.contactDesc,
          fundName: values?.selectedFund || "",
          firstName: memberData.firstName,
          lastName: memberData.lastName,
          city: cityLabel,
          street: memberData?.street || "",
          postOfficeBox: memberData?.postOfficeCode || "",
          zipCode: memberData?.postCode || "",
          email: memberData.email,
          phone: memberData.phone || "",
          cellPhone: memberData.cellPhone,
          attachments: selectedFiles.length ? selectedFiles : null,
        };
        const submitStatus = await SendContactMail(contactData);
        if (submitStatus) {
          setLoading(false);
          openRequestAcceptedPopup();
        } else {
          setLoading(false);
          openRequestFailedPopup();
        }
      } else {
        setLoading(false);
        openRequestFailedPopup();
      }
    },
  });

  
  const InputFocus =  useInputFocus(formik.errors, formik.submitCount , clickbtnsub);
  useEffect(() => {
    if(InputFocus){
      setClickbtnsub(false);
    }
  }, [InputFocus]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<Attachments[]>([]);
  const [fileError, setFileError] = useState<boolean>(false);
  const [fileErrorLabel, setFileErrorLabel] = useState<string>("");
  const timer = useRef<any>(null);

  const requestOptions = [
    t("contactPopupForm.requestOption1"),
    t("contactPopupForm.requestOption2"),
    t("contactPopupForm.requestOption3"),
    t("contactPopupForm.requestOption4"),
    t("contactPopupForm.requestOption5"),
    t("contactPopupForm.requestOption6"),
    t("contactPopupForm.requestOption7"),
  ];

  const isValidFile = (file: any) => {
    const fileType = file.name.split(".")[1];
    if (file.size > FIVE_MB_IN_BYTES) {
      setFileError(true);
      setFileErrorLabel(t("contactPopupForm.bigFile"));
      return false;
    } else if (
      !(
        fileType === "jpg"  || fileType === "JPG"  ||
        fileType === "jpeg" || fileType === "JPEG" ||
        fileType === "tiff" || fileType === "TIFF" ||
        fileType === "gif"  || fileType === "GIF"  ||
        fileType === "pdf"  || fileType === "PDF"
      )
    ) {
      setFileError(true);
      setFileErrorLabel(t("contactPopupForm.fileTypeError"));
      return false;
    } else if (
      // check if file already uploaded.
      selectedFiles?.filter(
        (selectedFile: Attachments) => file.name === selectedFile.fileName
      ).length
    ) {
      setFileError(true);
      setFileErrorLabel(t("contactPopupForm.fileExistError"));
      return false;
    }
    return true;
  };

  const handleFilePicker = (e: any) => {
    if (selectedFiles.length === 3) {
      setFileError(true);
      setFileErrorLabel(t("contactPopupForm.toMuchFiles"));
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        setFileError(false);
        setFileErrorLabel("");
      }, 5000);
    } else {
      const reader = new FileReader();
      if (e.target.files[0]) {
        if (isValidFile(e.target.files[0])) {
          fileError && setFileError(false);
          fileErrorLabel.length && setFileErrorLabel("");

          reader.readAsDataURL(e.target.files[0]);
          reader.onload = (readerEvent: any) => {
            setSelectedFiles((selectedFiles: Attachments[]) => {
              return [
                ...selectedFiles,
                {
                  fileName: e.target?.files[0].name,
                  base64: readerEvent.target.result.replace(
                    `data:${e.target.files[0].type};base64,`,
                    ""
                  ),
                },
              ];
            });
            e.target.value = null;
          };
        }
      }
    }
  };

  const deleteFile = (index: number) => {
    if (selectedFiles && selectedFiles.length) {
      let files = [...selectedFiles];
      files.splice(index, 1);
      setSelectedFiles(files);
    }
  };

  const getCityLabelByCode = async (cityCode: string) => {
    const cities = await GetCities();
    if (cities && cities.length) {
      const cityLabel = getCityLabel(cities, cityCode);
      return cityLabel;
    }
    return "";
  };

  const openRequestAcceptedPopup = () => {
    // Handles open request accepts popup
    dispatch(setModalState(true));
    dispatch(setModalChild(<RequestAcceptedPopup size={"m"} center={true} />));
  };

  const openRequestFailedPopup = () => {
    dispatch(
      setModalChild(
        <ErrorPopup
          label={t("contactPopupForm.contactError")}
          size={"m"}
          center={true}
        />
      )
    );
  };

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return (
    <form className="container contant-form" onSubmit={formik.handleSubmit}>
      <div className="contact-popup-title-wrapper">
        <img src={messageIcon} alt="" />
        <h3 id="dialogTitle">{t("contactPopupForm.title")}</h3>
      </div>
      {/* TODP -AA check type error */}
      {/* @ts-ignore:next-line */}
      <Row md={12} className="justify-content-between fields-wrap">
        <FormControl
          variant="standard"
          sx={{ m: 1, minWidth: 120 }}
          className={`col-5 reg-input-focus ${
            formik.errors.selectedFund && formik.submitCount
              ? "reg-input-error"
              : ""
          }`}
        >
          <InputLabel id="demo-simple-select-standard-label" htmlFor="selectedFund">
            {t("contactPopupForm.input1")}
          </InputLabel>
          <Select
            id="selectedFund"
            name="selectedFund"
            value={formik.values.selectedFund}
            onChange={formik.handleChange}
            IconComponent={KeyboardArrowDownIcon}
            aria-labelledby="selectedFund"
            aria-describedby="selectedFund"
            aria-required="true"
            aria-label={t("contactPopupForm.input1")}
            autoFocus={true}
            inputProps={{
              "aria-required":"true"
            }}
          >
            {getUserFunds()?.map((fund: UserFund, index: number) => (
              <MenuItem key={index} value={`${fund.fundLabel}`}>
                {`${fund.fundLabel}`}
              </MenuItem>
            ))}
          </Select>
          {formik.errors.selectedFund && formik.submitCount ? (
            <div style={{ marginTop: 5 }}>
              <RenderInputError id="selectedFund" errorLabel={formik.errors.selectedFund} />            
            </div>
          ) : null}
        </FormControl>
        
        <FormControl
          variant="standard"
          sx={{ m: 1, minWidth: 120 }}
          className={`col-5 reg-input-focus ${
            formik.errors.contactSubject && formik.submitCount
              ? "reg-input-error"
              : ""
          }`}
        >
          
          <InputLabel id="demo-simple-select-standard-label" htmlFor="contactSubject">
           <div className="contact-subject" 
           >
             {t("contactPopupForm.input2")}
            <div className="contact-subject-star">*</div>
           </div>     
          </InputLabel>
         
          <Select
            id="contactSubject"
            name="contactSubject"
            value={formik.values.contactSubject}
            onChange={formik.handleChange}
            IconComponent={KeyboardArrowDownIcon}
            aria-labelledby="contactSubject"
            aria-describedby="contactSubject"
            aria-required="true"
            aria-label={t("contactPopupForm.input2")}
            inputProps={{
              "aria-required":"true"
            }}
          >
            {requestOptions.map((option: string) => (
              <MenuItem key={option} value={option} aria-required="true">
                {option}
              </MenuItem>
            ))}
          </Select>
          {formik.errors.contactSubject && formik.submitCount ? (
            <div style={{ marginTop: 5 }}>
              <RenderInputError id="contactSubject" errorLabel={formik.errors.contactSubject}/>
            </div>
          ) : null}
        </FormControl>
      </Row>

      <FormGroup>
        <h5>
          {/* TODP -AA check type error */}
          {/* @ts-ignore:next-line */}
          <Label id="textBoxTitle" htmlFor="contactDesc">
          <div className="contact-desc">
            {t("contactPopupForm.input2")}
            <div className="contact-desc-star">*</div>          
          </div> 
            </Label>
        </h5>
        <textarea
          className={`form-control ${
            formik.errors.contactDesc && formik.submitCount
              ? "textarea-error"
              : ""
          }`}
          id="contactDesc"
          name="contactDesc"
          value={formik.values.contactDesc}
          onChange={formik.handleChange}
          placeholder={t("contactPopupForm.textBoxPlaceholder")}          
          aria-required="true"
          aria-describedby="contactDesc"
          
        ></textarea>
        {formik.errors.contactDesc && formik.submitCount ? (
          <div style={{ marginTop: -10, marginBottom: 10 }}>
            <RenderInputError id="contactDesc" errorLabel={formik.errors.contactDesc} style={{color:'green'}}
              inputLabel={t("contactPopupForm.input2")} />
          </div>
        ) : null}
      </FormGroup>
      <div className="wrap-file">
        <div
          className="d-flex align-items-center"
          style={{ flexDirection: "column" }}
        >
          <div
            className="contact-popup-wrap-input"
            style={{ cursor: "pointer", marginBottom: 10, marginLeft:80}}
          >
            <img alt="attachment" src={attachment} />
            {t("contactPopupForm.addFile")}
            <input
            title={t("contactPopupForm.addFile")}
              id="file-input"
              className="input-ignore-outline"
              name="file-input"
              type="file"
              accept=".pdf, .tiff, .jpeg, .gif, .jpg, .png"
              onChange={handleFilePicker}
              onKeyPress={(event) =>
                isEnterPress(event) && handleFilePicker(event)
              }
              tabIndex={0}
            />
          </div>
          {selectedFiles.length
            ? selectedFiles.map((selectedFile: Attachments, index: number) => (
             
                 <div key={index} className="contact-popup-wrap-chip">
              <MuiChipCustom              
                sx={{marginBottom: 1}}                   
                label={
                  selectedFile.fileName.length > 25
                    ? selectedFile.fileName.slice(0, 24) + "..."
                    : selectedFile.fileName
                }
                onDelete={() => deleteFile(index)}
                key={selectedFile.fileName}
                title={t("contactPopupForm.deleteFile")}
                aria-labelledby={t("contactPopupForm.deleteFileButton")}
              />
            </div>
           
               
              ))
            : null}
        </div>
      </div>
      {fileError ? (
        <div style={{ marginTop: 5 }}>
          <RenderInputError errorLabel={fileErrorLabel} />
        </div>
      ) : null}
      <button type="submit" disabled={loading} onClick={()=>setClickbtnsub(true)}>
        {loading ? t("general.loading") : t("contactPopupForm.send")}
      </button>
    </form>
  );
};

export default ContantPopupForm;
